import React from 'react';
import IconBase from './shared/icon-base';
import { jsx as ___EmotionJSX } from "@emotion/core";
export default function PaperPlaneIcon(props) {
  return ___EmotionJSX(IconBase, props, ___EmotionJSX("path", {
    d: "M14 4V2L18 5L14 8V6H3C3 6.44238 3.22998 6.85693 3.59961 7.08252L11.3223 12.3765C11.7344 12.6587 12.2656 12.6587 12.6777 12.3765L20.3555 7.11182C20.77 6.85693 21 6.44238 21 6H23L22.9665 6.25763C22.8825 7.29291 22.3284 8.24951 21.4414 8.79053L13.8086 14.0259C13.2593 14.4023 12.6294 14.5908 12 14.5908C11.3701 14.5908 10.7407 14.4023 10.1914 14.0259L2.51367 8.76123C1.66925 8.24793 1.11877 7.29517 1.03381 6.2616L1 4H14Z",
    fill: "currentColor"
  }), ___EmotionJSX("path", {
    d: "M21 17V10.9103L22.2227 10.0713C22.5067 9.89801 22.7623 9.68958 23 9.46387V17C23 18.6543 21.6543 20 20 20H4C2.3457 20 1 18.6543 1 17V9.48267C1.20703 9.67487 1.4256 9.85309 1.66553 9.99854L3 10.9136V17C3 17.5513 3.44873 18 4 18H20C20.5513 18 21 17.5513 21 17Z",
    fill: "currentColor"
  }));
}